import { render, staticRenderFns } from "./LabNotice.vue?vue&type=template&id=c590d77e&scoped=true&"
import script from "./LabNotice.vue?vue&type=script&lang=js&"
export * from "./LabNotice.vue?vue&type=script&lang=js&"
import style0 from "./LabNotice.vue?vue&type=style&index=0&id=c590d77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c590d77e",
  null
  
)

export default component.exports